
// eslint-disable-next-line 
import { UserModel } from "@/domain/models";
import { userService } from "@/domain/services";
import { defineComponent } from "vue";
import { mapState, mapActions } from "vuex";

export default defineComponent({
  name: "UserList",
  computed: {
    ...mapState("users", ["users", "isLoading"]),
  },
  created() {
    this.loadUsers();
  },
  methods: {
    toogleStatus(user: UserModel) {
      userService.update(user.id, { active: !user.active}).then(() => {
        this.loadUsers();
      });
    },
    ...mapActions({ loadUsers: "users/load" }),
  },
});
